module.exports = __webpack_public_path__ + "img/tebrikler.06d9d563.png";